import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  item: {
    alignItems: 'start',

    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
    },

    '&:focus-within': {
      outline: 'auto',
      outlineOffset: '4px',
      outlineColor: '#888',
    },
  },
  input: {
    width: 12,
    height: 12,
    padding: 0,
    margin: '8px 16px 0 16px',

    [theme.breakpoints.down('sm')]: {
      width: 20,
      height: 20,
      margin: '8px 16px 16px 12px',

      '& > span > svg': {
        width: '100%',
        height: '100%',
      },
    },
  },
}));
